import { useToast } from '../../lib/use-toast';
import { attachDriverDocument, getDriverDocumentDownloadUrl, uploadDriverDocumentFile } from './drivers.api';

export interface UploadDriverDocumentInput {
  documentTypeId: string;
  file: File;
  number: string;
  issuer: string;
  issueDate: string;
  expiryDate: string;
}

/** The Documents tab's mutations: presign → direct upload → confirm (CLAUDE.md → storage rule) — the file never passes through the API body. Add and renew are the same call; the server decides which it was. */
export function useDriverDocuments(driverId: string, reload: () => Promise<void>) {
  const toast = useToast();

  async function uploadDocument(input: UploadDriverDocumentInput, isRenewal: boolean): Promise<boolean> {
    try {
      const { key, contentType } = await uploadDriverDocumentFile(driverId, input.file);
      await attachDriverDocument(driverId, {
        documentTypeId: input.documentTypeId,
        key,
        contentType,
        number: input.number,
        issuer: input.issuer,
        issueDate: input.issueDate,
        expiryDate: input.expiryDate,
      });
      await reload();
      toast.success(isRenewal ? 'Document renewed' : 'Document added');
      return true;
    } catch {
      toast.error(isRenewal ? "Couldn't renew the document" : "Couldn't add the document");
      return false;
    }
  }

  async function openDocument(documentId: string): Promise<void> {
    try {
      const { url } = await getDriverDocumentDownloadUrl(driverId, documentId);
      window.open(url, '_blank', 'noopener');
    } catch {
      toast.error("Couldn't open the document");
    }
  }

  return { uploadDocument, openDocument };
}
